import moment from "moment-timezone";

export const getInitialOrderDate = (threshold = 15) => {
  return moment().tz("Australia/Sydney").hour(9).seconds(0);
};
